/**
 * @class routeHelper.
 *
 */
import { createHashHistory } from 'history';
import store from '../../../reducers/storeRegistration';
import notificationActions from '../../../actions/notificationActionCreators';
const hashHistory = createHashHistory();

/* eslint class-methods-use-this:
  ["error", { "exceptMethods": [
    "handleViewRedirect",
    "transitionAsync",
    "updateURL",
    "displayModal"
  ] }]
*/
// Needs to stay a class to allow us to bind components to transitionAsync calls
class RouteHelper {
  handleViewRedirect(canView, currentLocation) {
    if (!canView) {
      const location = currentLocation ? `: ${currentLocation.pathname}` : '';
      store.dispatch(notificationActions.error({
        message: `You are not authorized to access this resource${location}.`
      }));
      hashHistory.replace('/accessDenied');
    }
  }
  updateURL(route = '/file-cabinet') {
    hashHistory.push(route);
  }
  handleEntityDoesNotExist(pathname) {
    this.updateURL(pathname);
    store.dispatch(notificationActions.error({
      headerMessage: 'Error fetching requested data',
      message: 'Please try again.'
    }));
  }
  transitionAsync(component, entity, next, safeRoutes = []) {
    if (!component || !component.props || !component.props[entity]) {
      throw new Error(`Component ${entity} is misconfigured`);
    }
    // if the next route is allowed, don't block the transition
    if (safeRoutes.length && safeRoutes.indexOf(next.pathname) !== -1) {
      return true;
    }
    const {
      loading,
      pendingChanges,
      error
    } = component.props[entity];
    // Handle 410 errors (entity deleted by another user)
    if (error && error.response && error.response.status === 410) {
      const entityActions = component.props[`${entity}Actions`];
      entityActions.showCancel(next.pathname);
      return true;
    }

    // cancel transition if data is loading
    if (loading && pendingChanges) {
      store.dispatch(notificationActions.info({
        headerMessage: 'Please wait, your changes are being saved.',
        message: 'If saving takes too long, you may be experiencing connection issues.'
      }));
      return false;
    }

    // Check for changes
    const entityActions = component.props[`${entity}Actions`];
    const {
      canEdit
    } = component.props;

    // If the user can't edit anyways, no point in bothering to block
    // the transition, just post the notice and let the transition carry on
    if (!canEdit) {
      store.dispatch(notificationActions.error({
        message: 'You are not authorized to make changes'
      }));
      entityActions.showCancel(next.pathname);
      return true; // Prompt will handle transition
    }

    // if true is not being returned, prompt still replaces the url with the
    // target, so we need to clean it up by changing it back to the current
    // location, otherwise subsequent navigations will fail
    hashHistory.replace(component.props.match.url);
    this.displayModal(component.handleSave, entityActions.showCancel, hashHistory.replace, next.pathname);
    return false;
  }

  /**
   * Display a modal with a set of actions
   */
  displayModal(yesAction, noAction, historyAction = () => {}, pathname = '') {
    store.dispatch(notificationActions.save({
      noAction: () => {
        noAction(pathname);
        historyAction(pathname);
      },
      yesAction: () => yesAction(pathname)
    }, {
      autoClose: false
    }));
    return false;
  }
}
export default new RouteHelper();